import React from 'react'
import'./Discliamer.css';
export default function Discliamer() {
  return (
    <>
    
    
    
    <section id="disclaimer" class="disclaimer-section">
  <div class="container">
    <h2>Disclaimer</h2>
    <p>At <strong>Home Appliance Service Madurai</strong>, we would like to clarify that we are not an authorized service center for any specific brand. We are an independent, multi-brand home appliance repair service provider. Our aim is to offer reliable and efficient repair services for various appliances, irrespective of their brand.</p>
    <p><strong>Important Notes:</strong></p>
    <ul>
      <li>We do not sell any products. Our focus is solely on providing quality repair services for home appliances.</li>
      <li>We are not affiliated with any manufacturer or brand. Our services are available for a variety of brands and appliance types.</li>
      <li>We are a trustworthy and professional service provider. We do not engage in fraudulent practices and prioritize customer satisfaction above all.</li>
    </ul>
    <p>If you have any questions or concerns, please do not hesitate to reach out to us. We are here to assist you with your home appliance repair needs!</p>
  </div>
</section>

    
    
    </>
  )
}
